
import { map3, zip3, map2, zip, length } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";

/**
 * Pair two lists, or say how long each of them was.
 */
export function checkedZip(xs, ys) {
    const matchValue = length(xs) | 0;
    const n2 = length(ys) | 0;
    const n1 = matchValue | 0;
    if (n1 === n2) {
        return new FSharpResult$2(/* Ok */ 0, [zip(xs, ys)]);
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [[n1, n2]]);
    }
}

/**
 * Combine two lists, or say how long each of them was.
 */
export function checkedMap2(mapping, xs, ys) {
    const matchValue = length(xs) | 0;
    const n2 = length(ys) | 0;
    const n1 = matchValue | 0;
    if (n1 === n2) {
        return new FSharpResult$2(/* Ok */ 0, [map2(mapping, xs, ys)]);
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [[n1, n2]]);
    }
}

/**
 * Pair three lists, or say how long each of them was.
 */
export function checkedZip3(xs, ys, zs) {
    const matchValue = length(xs) | 0;
    const matchValue_1 = length(ys) | 0;
    const n3 = length(zs) | 0;
    const n2 = matchValue_1 | 0;
    const n1 = matchValue | 0;
    if ((n1 === n2) && (n1 === n3)) {
        return new FSharpResult$2(/* Ok */ 0, [zip3(xs, ys, zs)]);
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [[n1, n2, n3]]);
    }
}

/**
 * Combine three lists, or say how long each of them was.
 */
export function checkedMap3(mapping, xs, ys, zs) {
    const matchValue = length(xs) | 0;
    const matchValue_1 = length(ys) | 0;
    const n3 = length(zs) | 0;
    const n2 = matchValue_1 | 0;
    const n1 = matchValue | 0;
    if ((n1 === n2) && (n1 === n3)) {
        return new FSharpResult$2(/* Ok */ 0, [map3(mapping, xs, ys, zs)]);
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [[n1, n2, n3]]);
    }
}

